import React from 'react'
import Modal from 'components/modal'

const TranslationErrorModal = props => {
    return(
    <Modal
        title={"Cannot Remove Translation"}
        isOpen={props.isOpen}
        className="confirmation-modal translation-error-modal"
        type="modal"
        autoFocusSubmit={false}
        submitBtnText="Ok"
        onCancel={props.onCancel}
        onSubmit={props.onSubmit}
        showCancelBtn={false}
    >
        <div className="translation-error-modal-body">
            <div className="translation-error-modal-text">
                <p> {props.t('delete.translations.error.message')} </p>
            </div>
        </div>
    </Modal>
    )
    }
export default TranslationErrorModal
